// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terminal .vue-typer{font-family:Courier New,Courier,monospace}.terminal .vue-typer .custom.char{color:green;background-color:#000}.terminal .vue-typer .custom.char.selected{background-color:green}.terminal .vue-typer .custom.caret{width:10px;background-color:green}", ""]);
// Exports
module.exports = exports;
